import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

/**
 * Keeps a daily insights page (Facebook, Google, TikTok) on the company the
 * user switches to.
 *
 * These pages fetch once, on mount, and CompanySelector changes the company
 * without navigating: the page stays mounted while changeCompanySaga clears
 * its slice. Without this the page stays empty until Refresh, or shows data
 * that changeCompanySaga re-fetched with the dashboard's dates under a date
 * picker still showing the page's own.
 *
 * On a company change it re-fetches with the page's own filters, minus the
 * campaign ids, which belong to the company the user left. The slice sagas
 * take the latest request, so this one, dispatched after the switch, wins
 * over the dashboard's.
 *
 * Returns the key for the page's DateRangeFilter. The filter copies its
 * initial values into its own state once, on mount, so a new key is the only
 * way to show the cleared campaign selection. It changes in the same render
 * as the filters it is handed, never before them.
 */
const useCompanySwitchRefresh = (selectedFilters, refresh) => {
  const companyId = useSelector((state) => state.Dashboard.companyId);
  const [filtersCompanyId, setFiltersCompanyId] = useState(companyId);

  useEffect(() => {
    if (companyId === filtersCompanyId) return;

    setFiltersCompanyId(companyId);
    refresh({ ...selectedFilters, campaignIds: null });
  }, [companyId, filtersCompanyId, selectedFilters, refresh]);

  return filtersCompanyId;
};

export default useCompanySwitchRefresh;
